import AccountSettings from "../views/AccountSettings/AccountSettings.jsx";
import Error404 from "../views/Errors/Error404";
import Home from "../views/Home/Home.jsx";
import LiveTrackerList from "../views/LiveTracker/LiveTrackerList.jsx";
import LiveTrackerMia from "../views/LiveTracker/LiveTrackerMia.jsx";
import DispatchOverview from "../views/DispatchOverview/DispatchOverview.jsx";
// import OrderRideWrapper from "../views/OrderRide/OrderRideWrapper.jsx";
import OrderRideWrapper from "../views/OrderRide/OrderRideWrapper.jsx";
import React from "react";
import RideHistory from "../views/RideHistory/RideHistory.jsx";
import BulkRideUpload from "../views/BulkRideUpload/BulkRideUpload.jsx";
import { Trans } from "react-i18next";
import WhiteLabelList from "../views/WhiteLabel/WhiteLabelList.jsx";
import WhiteLabelForm from "../views/WhiteLabel/WhiteLabelForm.jsx";
import Payment from "../views/Payment/Payment.jsx";
import StaggeringSettings from "../views/StaggeringSettings/StaggeringSettings.js";

var dashboardRoutes = [
  {
    path: "/home",
    name: <Trans>HOME</Trans>,
    icon: "pe-7s-graph",
    component: Home,
  },
  {
    path: "/live_tracker_list",
    name: <Trans>LIVETRACKER</Trans>,
    icon: "pe-7s-bell",
    component: LiveTrackerList,
  },
  {
    path: "/live_tracker",
    name: <Trans>LIVETRACKER</Trans>,
    hideOnSidebar: true,
    component: LiveTrackerMia,
  },
  {
    path: "/dispatch_overview",
    name: <Trans>DISPATCH_OVERVIEW</Trans>,
    icon: "pe-7s-clock",
    component: DispatchOverview,    
    hideOnSidebar: false,
    shouldHide: (state) => {
      // Check if impersonating partner 89 or 1, or logged in as partner 89 or 1
      const impersonatedPartnerId = state && state.partners && state.partners.impersonated_partner
        ? state.partners.impersonated_partner.partner_id
        : null;
      const loggedInPartnerId = state && state.userData ? state.userData.partnerId : null;
      const currentPartnerId = impersonatedPartnerId || loggedInPartnerId;
      return currentPartnerId !== 89 && currentPartnerId !== 1;
    },
  },
  {
    path: "/not_found",
    hideOnSidebar: true,
    name: <Trans>404</Trans>,
    component: Error404,
  },
  {
    path: "/order_ride",
    name: <Trans>ORDER_DELIVERY</Trans>,
    icon: "pe-7s-way",
    component: OrderRideWrapper,
  },
  {
    path: "/bulk_upload",
    name: <Trans>IMPORT_ORDERS</Trans>,
    icon: "pe-7s-file",
    component: BulkRideUpload,
    hideOnSidebar: true,
  },
  {
    path: "/history",
    name: <Trans>DELIVERY_HISTORY</Trans>,
    icon: "pe-7s-car",
    component: RideHistory,
  },
  //{
  //  path: "/white_label_list",
  //  name: <Trans>WHITE_LABEL</Trans>,
  //  icon: "pe-7s-pen",
  //  component: WhiteLabelList
  //},
  {
    path: "/invoices",
    name: <Trans>PAYMENT</Trans>,
    icon: "pe-7s-cash",
    component: Payment,
  },
  {
    path: "/staggering_settings",
    name: <Trans>STAGGERING_SETTINGS</Trans>,
    icon: "pe-7s-config",
    component: StaggeringSettings,
    hideOnSidebar: false,
    shouldHide: (state) => {
      // Check if impersonating partner 89 or 1, or logged in as partner 89 or 1
      const impersonatedPartnerId = state && state.partners && state.partners.impersonated_partner
        ? state.partners.impersonated_partner.partner_id
        : null;
      const loggedInPartnerId = state && state.userData ? state.userData.partnerId : null;
      const currentPartnerId = impersonatedPartnerId || loggedInPartnerId;
      return currentPartnerId !== 89 && currentPartnerId !== 1;
    },
  },
  //{
  //  path: "/white_label/:white_label_id",
  //  hideOnSidebar: true,
  //  name: <Trans>WHITE_LABEL</Trans>,
  //  component: WhiteLabelForm,
  //},
  //{
  //  path: "/account_settings",
  //  name: <Trans>ACCOUNT_SETTINGS</Trans>,
  //  icon: "pe-7s-settings",
  //  component: AccountSettings
  //},
  {
    path: "/",
    name: <Trans>HOME</Trans>,
    component: Home,
    hideOnSidebar: true,
  },
];
export default dashboardRoutes;
